module.exports = __webpack_public_path__ + "images/lpage-leaderboard-2.png";